/**
 * @fileoverview `@puffin-core/error-handling` — the Spanish (ES) bundle, namespace #57 `errorHandling`.
 * @package @puffin-core/error-handling
 *
 * Mirrors `en.js` leaf for leaf; `_meta.js` records each leaf's provenance (the moved leaves keep pos-web's flags).
 *
 * @module @puffin-core/error-handling/strings/es
 */

export const ERROR_HANDLING_ES = Object.freeze({
  notifications: Object.freeze({
    errorTitle: Object.freeze({
      system: 'Error del sistema',
      ui: 'Error de interfaz',
      api: 'Error de API',
      database: 'Error de base de datos',
      validation: 'Error de validación',
      network: 'Error de red',
      security: 'Error de seguridad',
      businessRule: 'Error de regla de negocio',
      performance: 'Problema de rendimiento',
      unknown: 'Error',
    }),
    errorTitleInComponent: '{{title}} en {{component}}',
    messageUnavailable: 'Se produjo un error desconocido',
  }),
  display: Object.freeze({
    network: Object.freeze({
      title: 'Error de conexión',
      message: 'No se pudo conectar con el servidor. Revise su conexión a internet.',
    }),
    timeout: Object.freeze({
      title: 'Tiempo de espera agotado',
      message: 'La solicitud tardó demasiado en completarse. Inténtelo de nuevo.',
    }),
    authentication: Object.freeze({
      title: 'Se requiere autenticación',
      message: 'Inicie sesión para continuar.',
    }),
    forbidden: Object.freeze({
      title: 'Acceso denegado',
      message: 'No tiene permiso para realizar esta acción.',
    }),
    notFound: Object.freeze({
      title: 'No encontrado',
      message: 'No se encontró el recurso solicitado.',
    }),
    validation: Object.freeze({
      title: 'Error de validación',
      message: 'Revise los datos introducidos e inténtelo de nuevo.',
    }),
    server: Object.freeze({
      title: 'Error del servidor',
      message: 'Se produjo un error inesperado en el servidor. Inténtelo de nuevo más tarde.',
    }),
    unknown: Object.freeze({
      title: 'Error',
      message: 'Se produjo un error. Inténtelo de nuevo.',
    }),
  }),
  // The words of every rule a 422 detail may carry (PPUR 5d server half, D-PPUR-25), keyed by the rule itself:
  // `@puffin-core/response-helpers` VALIDATION_RULES, judged in both directions by `validationRulesWorded.contract`.
  // {{field}} is the field's label; {{limit}}, {{valids}} and {{name}} are the detail's whitelisted params.
  validationRule: Object.freeze({
    'actions.none': 'Se requiere al menos una acción.',
    'address.country': '{{field}} no corresponde a ningún país.',
    'address.countryCodeNotAllowed': '{{field}} no es un país en el que se pueda registrar una dirección.',
    'address.invalid': 'La dirección está incompleta o no es válida.',
    'address.postalCodeInvalidForCountry': '{{field}} no es un código postal válido para el país seleccionado.',
    'address.stateCodeCountryMismatch': '{{field}} no pertenece al país seleccionado.',
    'alternatives.all': '{{field}} no cumple todos los requisitos.',
    'alternatives.any': '{{field}} no coincide con ninguna forma permitida.',
    'alternatives.match': '{{field}} no coincide con ninguna forma permitida.',
    'alternatives.one': '{{field}} coincide con más de una forma permitida.',
    'alternatives.types': '{{field}} no es de un tipo permitido.',
    'any.custom': '{{field}} no es válido.',
    'any.default': 'No se pudo asignar el valor predeterminado a {{field}}.',
    'any.failover': 'No se pudo asignar el valor alternativo a {{field}}.',
    'any.invalid': '{{field}} no es un valor permitido.',
    'any.only': '{{field}} debe ser uno de: {{valids}}.',
    'any.ref': '{{field}} hace referencia a un valor no válido.',
    'any.required': '{{field}} es obligatorio.',
    'any.ruleDate': '{{field}} debe ser una fecha real del calendario.',
    'any.unknown': '{{field}} no está permitido aquí.',
    'area.pastTheEdge': '{{field}} sobrepasa el borde del área.',
    'array.base': '{{field}} debe ser una lista.',
    'array.excludes': '{{field}} contiene un elemento no permitido.',
    'array.hasKnown': 'A {{field}} le falta un elemento obligatorio.',
    'array.hasUnknown': 'A {{field}} le falta un elemento obligatorio.',
    'array.includes': '{{field}} contiene un elemento no válido.',
    'array.includesRequiredBoth': 'A {{field}} le faltan elementos obligatorios.',
    'array.includesRequiredKnowns': 'A {{field}} le faltan elementos obligatorios.',
    'array.includesRequiredUnknowns': 'A {{field}} le faltan elementos obligatorios.',
    'array.length': '{{field}} debe tener exactamente {{limit}} elementos.',
    'array.max': '{{field}} puede tener como máximo {{limit}} elementos.',
    'array.min': '{{field}} debe tener al menos {{limit}} elementos.',
    'array.orderedLength': '{{field}} debe tener como máximo {{limit}} elementos.',
    'array.sort': '{{field}} no está en el orden requerido.',
    'array.sort.mismatching': '{{field}} no se puede ordenar: sus elementos son de tipos distintos.',
    'array.sort.unsupported': '{{field}} no se puede ordenar de esta manera.',
    'array.sparse': '{{field}} no debe tener elementos vacíos.',
    'array.unique': '{{field}} tiene un elemento repetido.',
    'band.belowLower': '{{field}} no debe ser inferior a la banda que tiene debajo.',
    'boolean.base': '{{field}} debe ser sí o no.',
    'branding.notInLibrary': '{{field}} debe ser una imagen de la biblioteca de medios del sitio.',
    'branding.toneUnreadable': '{{field}} es demasiado difícil de leer sobre su fondo.',
    'branding.tonesNeedBase': '{{field}} necesita que primero se definan los colores de papel y de tinta.',
    'branding.unreadable': '{{field}} es demasiado difícil de leer sobre el color del papel.',
    'captions.multipleDefaults': 'Solo un subtítulo puede ser el predeterminado.',
    'charge.quote': '{{field}} debe ser el precio que se le mostró.',
    'contact.invalid': '{{field}} debe ser una dirección de correo electrónico o un número de teléfono.',
    'content.date': '{{field}} debe ser un día real del calendario.',
    'content.destination': '{{field}} debe ser una dirección web o una página de este sitio.',
    'content.href': '{{field}} debe ser una dirección web o una página de este sitio.',
    'content.key': '{{field}} debe estar formado por palabras en minúsculas unidas por guiones y empezar por una letra.',
    'date.base': '{{field}} debe ser una fecha válida.',
    'date.format': '{{field}} no tiene el formato de fecha esperado.',
    'date.format.iso': '{{field}} debe ser una fecha ISO.',
    'date.format.javascript': '{{field}} debe ser una marca de tiempo.',
    'date.format.unix': '{{field}} debe ser una marca de tiempo Unix.',
    'date.greater': '{{field}} debe ser posterior a la fecha permitida.',
    'date.less': '{{field}} debe ser anterior a la fecha permitida.',
    'date.max': '{{field}} no debe ser posterior a la fecha permitida.',
    'date.min': '{{field}} no debe ser anterior a la fecha permitida.',
    'countDenominations.sum': '{{field}} debe sumar exactamente el importe contado.',
    'departmentPlan.groupIdentity': '{{field}} debe indicar un grupo existente o uno nuevo, no ambos.',
    'departmentPlan.groupMismatch': '{{field}} indica un grupo que no está en el plan.',
    'departmentPlan.groupProvenance': '{{field}} no coincide con la forma en que se creó el grupo.',
    'departmentPlan.memberAmountUnknown': '{{field}} indica un departamento que no está en el grupo.',
    'departmentPlan.memberDuplicate': 'Un departamento solo puede pertenecer a un grupo.',
    'duration.defaultOutOfRange': '{{field}} debe estar entre las duraciones mínima y máxima.',
    'duration.minAboveMax': '{{field}} no puede ser mayor que la duración máxima.',
    'field.defaultValueNotText': '{{field}} solo se aplica a un campo de texto.',
    'field.defaultValueTooLong': '{{field}} no debe superar la longitud máxima del campo.',
    'field.maxLengthNotText': '{{field}} solo se aplica a un campo de texto.',
    'field.placeholderNotText': '{{field}} solo se aplica a un campo de texto.',
    'field.rowsNotTextarea': '{{field}} solo se aplica a un campo de texto de varias líneas.',
    'filters.json': '{{field}} debe ser un conjunto de filtros.',
    'function.arity': '{{field}} debe recibir exactamente {{limit}} argumentos.',
    'function.class': '{{field}} debe ser una clase.',
    'function.maxArity': '{{field}} puede recibir como máximo {{limit}} argumentos.',
    'function.minArity': '{{field}} debe recibir al menos {{limit}} argumentos.',
    'garnishment.agencyUnknown':
      'No se pudo leer la agencia de manutención de menores de este estado, así que la orden no se puede enviar.',
    'garnishment.fipsNotListed': 'Este código de condado no figura en la lista de la agencia del estado.',
    'garnishment.invalidPercentage': 'Ingrese un porcentaje mayor que 0 y no mayor que 100.',
    'garnishment.overFederalCeiling': 'Esto supera lo que la ley federal permite retener.',
    'garnishment.overStateCeiling': 'Esto supera lo que la ley del estado donde trabaja el empleado permite retener.',
    'garnishment.payPeriodExceedsAnnual':
      'El máximo por período de pago no puede ser mayor que el máximo anual.',
    'garnishment.requiredAttributeMissing': 'La agencia del estado requiere este número.',
    'garnishment.stateBarsOrder': 'La ley del estado donde trabaja el empleado no permite este tipo de orden sobre el salario.',
    'jurisdiction.code': '{{field}} no es una jurisdicción.',
    'jurisdiction.parentNotAState': '{{field}} debe ser un estado conocido.',
    'leaveType.needsBalance': '{{field}} requiere que el tipo de ausencia cuente contra un saldo.',
    'lifecycle.order': '{{field}} no puede ser anterior a la fecha de apertura.',
    'location.notAuthorized': '{{field}} no es una de sus ubicaciones autorizadas.',
    'lyWindow.order': '{{field}} no debe empezar después de terminar.',
    'measurement.incomplete':
      '{{field}} debe indicarse con el resto de su medida: un peso con su unidad, o el largo, el ancho y el alto con su unidad.',
    'metrics.unknown': '{{field}} indica una métrica que este informe no tiene.',
    'mfaPolicy.optOutEnabled': 'No se puede excluir {{field}} mientras está activado.',
    'mfaPolicy.optOutRequired': '{{field}} es obligatorio y no se puede excluir.',
    'navigation.url': '{{field}} debe ser una dirección web, un enlace de correo o una página de este sitio.',
    'number.base': '{{field}} debe ser un número.',
    'number.greater': '{{field}} debe ser mayor que {{limit}}.',
    'number.infinity': '{{field}} debe ser un número finito.',
    'number.integer': '{{field}} debe ser un número entero.',
    'number.less': '{{field}} debe ser menor que {{limit}}.',
    'number.max': '{{field}} debe ser como máximo {{limit}}.',
    'number.min': '{{field}} debe ser al menos {{limit}}.',
    'number.multiple': '{{field}} debe ser múltiplo de {{limit}}.',
    'number.negative': '{{field}} debe ser un número negativo.',
    'number.port': '{{field}} debe ser un número de puerto.',
    'number.positive': '{{field}} debe ser un número positivo.',
    'number.precision': '{{field}} puede tener como máximo {{limit}} decimales.',
    'number.unsafe': '{{field}} es demasiado grande para guardarse con exactitud.',
    'object.and': '{{field}} debe indicarse junto con sus campos relacionados.',
    'object.assert': '{{field}} no cumple su regla.',
    'object.base': '{{field}} debe ser un conjunto de valores.',
    'object.instance': '{{field}} no es del tipo esperado.',
    'object.length': '{{field}} debe tener exactamente {{limit}} valores.',
    'object.max': '{{field}} puede tener como máximo {{limit}} valores.',
    'object.min': '{{field}} debe tener al menos {{limit}} valores.',
    'object.missing': 'Debe indicarse al menos uno de los campos obligatorios.',
    'object.nand': '{{field}} no puede indicarse junto con todos sus campos relacionados.',
    'object.oxor': 'Solo puede indicarse uno de estos campos.',
    'object.pattern.match': '{{field}} tiene un valor no válido.',
    'object.refType': '{{field}} debe hacer referencia a un valor.',
    'object.regex': '{{field}} debe ser un patrón.',
    'object.rename.multiple': '{{field}} se indicó más de una vez.',
    'object.rename.override': '{{field}} se indicó más de una vez.',
    'object.rename.proto': '{{field}} no está permitido aquí.',
    'object.schema': '{{field}} debe ser un esquema.',
    'object.unknown': '{{field}} no está permitido aquí.',
    'object.with': '{{field}} también necesita su campo relacionado.',
    'object.without': '{{field}} no puede indicarse junto con un campo relacionado.',
    'object.xor': 'Debe indicarse exactamente uno de estos campos.',
    'operatingHours.week': 'El horario semanal no es válido.',
    'parameters.undeclared': '{{field}} tiene un ajuste que esta regla no admite.',
    'permission.coveredByGrant':
      '{{field}} sigue concedido por un permiso más amplio: revoque ese permiso en su lugar.',
    'permission.notDelegatable':
      '{{field}} es un permiso que usted no tiene, así que no puede concederlo.',
    'permission.pairIncoherent':
      '{{field}} necesita su permiso de visualización: conceda ambos o revoque ambos.',
    'permission.unknown': '{{field}} no es un permiso conocido.',
    'phone.notTextable': '{{field}} no puede recibir mensajes de texto: use un número móvil.',
    'placeId.shape': '{{field}} debe ser un ID de lugar de Google Business Profile.',
    'placeId.text': '{{field}} debe ser texto.',
    'product.departmentRequired': '{{field}} sigue al departamento del producto, así que elija un departamento.',
    'product.notApplicable': '{{field}} no corresponde al producto tal como está configurado.',
    'product.weightNeededToShip': '{{field}} es obligatorio para un producto que se envía.',
    'range.reversed': '{{field}} no debe ser anterior a la fecha de inicio.',
    'range.tooLong': 'El intervalo de fechas es demasiado largo.',
    'reportDefinition.createOnly': '{{field}} no se puede cambiar después de crear el informe.',
    'roleLimit.notDelegatable': '{{field}} supera su propio límite de {{limit}}, así que no puede establecerlo.',
    'setting.order': '{{field}} debe ser como máximo {{limit}}, el ajuste que no puede superar.',
    'signatureStrokes.invalid': '{{field}} no es una firma.',
    'siteLink.url': '{{field}} debe ser una dirección web, un enlace de correo o una página de este sitio.',
    'span.reversed': '{{field}} no debe ser anterior al inicio.',
    'span.tooLong': 'El intervalo es demasiado largo.',
    'string.alphanum': '{{field}} solo puede contener letras y números.',
    'string.base': '{{field}} debe ser texto.',
    'string.base64': '{{field}} debe ser texto en base64.',
    'string.civilDate': '{{field}} debe ser una fecha real del calendario.',
    'string.creditCard': '{{field}} debe ser un número de tarjeta.',
    'string.dataUri': '{{field}} debe ser un URI de datos.',
    'string.domain': '{{field}} debe ser un nombre de dominio.',
    'string.email': '{{field}} debe ser una dirección de correo electrónico.',
    'string.empty': '{{field}} no debe estar vacío.',
    'string.guid': '{{field}} debe ser un GUID.',
    'string.hex': '{{field}} debe ser hexadecimal.',
    'string.hexAlign': '{{field}} debe tener un número par de dígitos hexadecimales.',
    'string.hostname': '{{field}} debe ser un nombre de host.',
    'string.ip': '{{field}} debe ser una dirección IP.',
    'string.ipVersion': '{{field}} debe ser una dirección IP de una versión permitida.',
    'string.isoDate': '{{field}} debe ser una fecha ISO.',
    'string.isoDuration': '{{field}} debe ser una duración ISO.',
    'string.length': '{{field}} debe tener exactamente {{limit}} caracteres.',
    'string.lowercase': '{{field}} debe estar en minúsculas.',
    'string.max': '{{field}} puede tener como máximo {{limit}} caracteres.',
    'string.min': '{{field}} debe tener al menos {{limit}} caracteres.',
    'string.normalize': '{{field}} debe ser texto Unicode normalizado.',
    'string.pattern.base': '{{field}} no tiene el formato esperado.',
    'string.pattern.invert.base': '{{field}} tiene un formato no permitido.',
    'string.pattern.invert.name': '{{field}} no debe ser un {{name}}.',
    'string.pattern.name': '{{field}} debe ser un {{name}}.',
    'string.semver': '{{field}} debe ser un número de versión.',
    'string.timeZone': '{{field}} debe ser una zona horaria.',
    'string.token': '{{field}} solo puede contener letras, números y guiones bajos.',
    'string.trim': '{{field}} no debe empezar ni terminar con espacios.',
    'string.uppercase': '{{field}} debe estar en mayúsculas.',
    'string.uri': '{{field}} debe ser una dirección web.',
    'string.uriCustomScheme': '{{field}} debe ser una dirección web de un tipo permitido.',
    'string.uriRelativeOnly': '{{field}} debe ser una dirección web relativa.',
    'string.wallClockTime': '{{field}} debe ser una hora del día (HH:mm:ss).',
    'systemSeed.immutable': '{{field}} no se puede cambiar en un tipo integrado.',
    'tender.details': 'Los detalles del pago no son válidos.',
    'timezone.iana': '{{field}} debe ser una zona horaria.',
    'upload.notAccepted': '{{field}} no es un archivo aceptado.',
    'user.active': '{{field}} no es un usuario activo de esta tienda.',
    'userIds.duplicate': '{{field}} indica un miembro del equipo más de una vez.',
    'userIds.malformed': '{{field}} debe ser una lista de miembros del equipo.',
    'userIds.tooMany': '{{field}} indica demasiados miembros del equipo.',
    'website.address': '{{field}} debe ser una dirección web.',
    'window.dayOutside': '{{field}} debe estar dentro del periodo.',
    'window.reversed': '{{field}} no debe ser anterior a la fecha de inicio.',
    'window.tooLong': 'El intervalo puede abarcar como máximo {{limit}} días.',
  }),
});

export default ERROR_HANDLING_ES;
